import { render, staticRenderFns } from "./EditProcedurePopup.vue?vue&type=template&id=7898ff1b&scoped=true&"
import script from "./EditProcedurePopup.vue?vue&type=script&lang=js&"
export * from "./EditProcedurePopup.vue?vue&type=script&lang=js&"
import style0 from "./EditProcedurePopup.vue?vue&type=style&index=0&id=7898ff1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7898ff1b",
  null
  
)

export default component.exports